import React from 'react';

import IconProps from 'packages/kakapo-ui-kit/assets/icons/IconProps';

function ArrowLeftIcon({ color = '#6C7680' }: IconProps) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14">
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<g fill={color} fillRule="nonzero" transform="translate(-352 -1205)">
					<path
						d="M367.818 1211.173a.615.615 0 01-.879 0l-5.302-5.89v15.075a.64.64 0 01-.637.642.64.64 0 01-.636-.642v-15.075l-5.303 5.89a.615.615 0 01-.879 0 .632.632 0 010-.887l6.306-7.004c.008-.011.02-.016.028-.026.017-.022.01-.052.03-.072.024-.025.06-.017.086-.036a.584.584 0 01.323-.136c.013 0 .024-.01.037-.01L361 1203l.01.002c.008 0 .014.004.022.005a.621.621 0 01.392.164c.009.008.022.005.03.013.009.008.005.022.013.03.008.01.006.024.013.033l6.338 7.04a.632.632 0 010 .886z"
						transform="matrix(0 1 1 0 -851 851)"
					/>
				</g>
			</g>
		</svg>
	);
}

export default ArrowLeftIcon;
